import React from 'react';

export function useState(defaultValue) {
  const [state, setState] = React.useState(defaultValue)
  const ref = React.useRef(state)

  const dispatch = React.useCallback(function (val) {
    ref.current = typeof val === "function" ?
      val(ref.current) : val

    setState(ref.current)
  }, []);

  return [state, dispatch, ref]
}

export function useRunOnce(fn, sessionKey, executeOn = () => true) {
  const isTriggered = React.useRef(false)
  React.useEffect(() => {
    const hasBeenTriggered = sessionKey ?
      sessionStorage.getItem(sessionKey) : isTriggered.current

    const executable = executeOn()
    if (!hasBeenTriggered && executable) {
      fn();
      isTriggered.current = true

      if (sessionKey) {
        sessionStorage.setItem(sessionKey, "true")
      }
    }

  }, [executeOn, fn, sessionKey]);
  return null
}